import React from 'react';
import { Grid } from '@material-ui/core';
import { isMobile } from 'react-device-detect';
import { IndeedChildrenProps } from './IndeedModels';
import SocialsRow from '../SocialsRow';

const BACKGROUND = require('assets/gradients/provider_home.png');

const IndeedHomeBase = ({ children }: IndeedChildrenProps) => {
    return (
        <Grid container direction="column" alignItems="center" justify="center" style={{ paddingBottom: 50 }}>
            <img
                src={BACKGROUND}
                style={{
                    position: 'absolute',
                    zIndex: -1,
                    backgroundRepeat: 'repeat',
                    width: '100%',
                    height: isMobile ? '800%' : '350%',
                }}
                alt=""
            />
            <Grid item container xs={10} direction="column">
                <Grid item xs={12} style={{ marginTop: 25 }}>
                    {children}
                </Grid>
                <Grid item style={{ marginTop: 25 }}>
                    <SocialsRow />
                </Grid>
            </Grid>
        </Grid>
    );
};

export default IndeedHomeBase;
